import dayjs from "utils/dayjs"; 
// import utc from "dayjs/plugin/utc";
// import timezone from "dayjs/plugin/timezone";
// import 'dayjs/locale/ko';
// import 'dayjs/locale/en';
// import 'dayjs/locale/zh-cn';
// import 'dayjs/locale/zh-tw';
import i18n from "i18next";

// dayjs.extend(utc);
// dayjs.extend(timezone);

// --------------------
// i18n ↔ dayjs locale 매핑
// --------------------
/**
 * i18n 언어 코드 → dayjs locale 매핑
 */
const I18N_TO_DAYJS = {
  ko: 'ko',
  en: 'en',
  'zh-CN': 'zh-cn',
//   'zh-TW': 'zh-tw',
};

/**
 * i18n 언어 코드 → dayjs locale로 적용
 * @param {string} i18nLang - i18n 언어 코드
 */
export function syncDayjsLocale(i18nLang) {
  // console.log(i18nLang)
  const dayjsLocale = I18N_TO_DAYJS[i18nLang] || 'ko';
  dayjs.locale(dayjsLocale);
  // console.log("Dayjs locale changed to:", dayjs.locale());
}

// 초기 동기화
syncDayjsLocale(i18n.language);

// // i18n 언어 변경 시 dayjs도 동기화
// i18n.on('languageChanged', (lng) => {
//   syncDayjsLocale(lng);
// });

const DEFAULT_TZ = process.env.REACT_APP_TIMEZONE || 'Asia/Seoul';

/**
 * 검색용 시작일 포맷팅 (00:00:00)
 */
export function toSearchStart(date) {
    if (!date) return "";
    return dayjs.tz(date, DEFAULT_TZ).startOf('day').format();
}

/**
 * 검색용 종료일 포맷팅 (23:59:59)
 */
export function toSearchEnd(date) {
    if (!date) return "";
    return dayjs.tz(date, DEFAULT_TZ).endOf('day').format();
}

/**
 * 1. 서버 저장용 타임존 포함 변환 (Offset 유지)
 * - 기존 .utc().toISOString() 대신 .format()을 사용하여 오프셋(+09:00)을 포함합니다.
 */
export function toServerFormat(date, options = {}) {
  const { 
    inputTz = DEFAULT_TZ, 
    defaultHour = 0 
  } = options;

  // 값이 없으면 null 반환 (부모 컴포넌트의 null 유지 요구사항 반영)
  if (!date) return null;

  let d = dayjs.tz(date, inputTz);

  // 날짜만 있는 문자열('YYYY-MM-DD')일 경우 시간 보정
  const isDateOnly = typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date);
  if (isDateOnly) {
    d = d.hour(defaultHour).minute(0).second(0).millisecond(0);
  }

  // 예: "2026-02-06T22:28:00+09:00"
  return d.format('YYYY-MM-DDTHH:mm:ssZ');
}

/**
 * 2. 서버 데이터 → 화면 표시 (타임존 명시)
 * - 서버에서 어떤 타임존으로 왔든, serviceTz(기본 서울)로 변환하여 보여줍니다.
 */
export function fromServerFormat(dateString, options = {}) {
  // 데이터가 없으면 빈 문자열 또는 '-' 반환
  if (!dateString) return "";

  const { 
    format = "YYYY-MM-DD HH:mm", 
    serviceTz = DEFAULT_TZ 
  } = options;

  // 입력된 문자열을 해석한 뒤, 지정된 타임존(tz)으로 변환하여 포맷팅합니다.
  return dayjs(dateString).tz(serviceTz).format(format);
}

export function nowFormat(format='YYYY-MM-DDTHH:mm:ssZ') {
  return dayjs().tz(DEFAULT_TZ).format(format);
}

export function nowTime() {
  return dayjs().tz(DEFAULT_TZ).valueOf();
}

/**
 * 3. 날짜만 서버용으로 변환 (YYYY-MM-DD)
 * 시간을 제외하고 날짜 문자열만 깔끔하게 보낼 때 사용
 */
export function toServerDateOnly(date) {
  // console.log("원본 데이터:", date);
  if (!date) return null;

  // [수정] .tz(DEFAULT_TZ)를 삭제합니다.
  // dayjs(date)로 읽은 뒤, 그 날짜의 연/월/일 정보만 그대로 포맷팅합니다.
  const formatted = dayjs(date).format('YYYY-MM-DD');
  
  // console.log("변환 후(타임존 제거):", formatted);
  return formatted;
}
// export function toServerDateOnly(date) {
//   console.log(date)
//   if (!date) return null;
//   // 타임존 계산 후 날짜 부분만 추출 (예: "2026-02-10")
//   console.log(dayjs(date).tz(DEFAULT_TZ).format('YYYY-MM-DD'));
//   return dayjs(date).tz(DEFAULT_TZ).format('YYYY-MM-DD');
// }

/**
 * 4. 서버 날짜(YYYY-MM-DD) -> 화면 표시
 * 서버에서 날짜 문자열만 왔을 때 안전하게 포맷팅
 */
export function fromServerDateOnly(dateString, format = 'YYYY-MM-DD') {
  if (!dateString) return "-";
  // 시간 정보가 없는 날짜는 dayjs가 로컬 자정으로 해석하므로 그대로 포맷팅
  return dayjs(dateString).format(format);
}

export const isValidDateTimeFormat = (dateStr) => {
    if (!dateStr) return false;

    // 1. YYYY-MM-DDTHH:mm:ss+08:00 포맷 형태인지 정규식 검사
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})$/;
    if (!isoRegex.test(dateStr)) return false;

    // 2. 실존하는 날짜 및 타임존 파싱이 정상인지 검사
    return dayjs(dateStr).isValid();
};

export const isValidDateFormat = (dateStr) => {
    if (!dateStr) return false;
    
    // YYYY-MM-DD 또는 YYYY.MM.DD 형태 정규식
    const dateRegex = /^\d{4}[-./]\d{2}[-./]\d{2}$/;
    if (!dateRegex.test(dateStr)) return false;
    
    // 실제로 존재하는 날짜인지 검증 (예: 2월 30일 차단)
    const normalized = dateStr.replace(/\./g, "-").replace(/\//g, "-");
    return dayjs(normalized).isValid();
};

// --------------------
// 서버 저장용 UTC 변환
// --------------------
/**
 * 서버 저장용 UTC 변환
 * - 날짜만 있는 경우 defaultHour를 적용
 * @param {string|Date} date - 입력 날짜 (예: '2026-01-26' 또는 '2026-01-26 15:30')
 * @param {string} inputTz - 입력 기준 TZ (예: 'Asia/Seoul')
 * @param {number} defaultHour - 날짜-only 입력일 때 적용할 시간 (기본: 0 → 자정)
 * @returns {string} UTC ISO 문자열
 */
export function toServerUTC(date, options = {}) {
  const { 
    inputTz = process.env.REACT_APP_TIMEZONE, 
    defaultHour = 0 
  } = options;

  // 날짜가 없으면 현재 시각으로 초기화
  let d = date 
    ? (inputTz ? dayjs.tz(date, inputTz) : dayjs(date))
    : (inputTz ? dayjs.tz(dayjs(), inputTz) : dayjs());

  // 날짜-only 문자열이면 defaultHour 적용
  const isDateOnly =
    typeof date === 'string' &&
    /^\d{4}-\d{2}-\d{2}$/.test(date);
  if (isDateOnly) {
    d = d.hour(defaultHour).minute(0).second(0).millisecond(0);
  }

  return d.utc().toISOString();
}

/**
 * 서버 UTC → 화면 표시
 * @param {string} utcDate - 서버에서 받은 UTC ISO 문자열
 * @param {string} serviceTz - 화면에 표시할 TZ (ex: 'Asia/Seoul')
 * @param {string} format - 포맷 (default: L LT)
 * @returns {string} 변환된 날짜 문자열
 */
export function fromServerUTC(utcDate, options = {}) {
  if (!utcDate) return "";
  const { format = "L LT", serviceTz = process.env.REACT_APP_TIMEZONE } = options;
  return dayjs.utc(utcDate).tz(serviceTz).format(format);
}
